import { Fragment } from "react";

const DAYS = ["Man", "Tir", "Ons", "Tor", "Fre", "Lør", "Søn"];
const DAYS_LONG = ["mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag", "søndag"];
const level = (v, max) => (v ? Math.min(4, Math.ceil((4 * v) / max)) : 0);

export default function StatsHeat({ heat, count }) {
  const max = Math.max(1, ...heat.flat());
  let best = null;
  heat.forEach((row, di) => row.forEach((v, h) => { if (v && (!best || v > best.v)) best = { v, di, h }; }));
  return (
    <section className="panel" data-testid="stats-heatmap">
      <h2>Hvornår siger kunderne ja tak?</h2>
      <p className="st-hint" data-testid="stats-heat-hint">
        {count && best
          ? <>Flest "ja tak" <b>{DAYS_LONG[best.di]} omkring kl. {String(best.h).padStart(2, "0")}</b> – slå gerne op lige før.</>
          : 'Vises når der er kommet "ja tak"-kommentarer i perioden.'}
      </p>
      <div className="st-heat-scroll">
        <div className="st-heat" role="img" aria-label="Antal ja tak fordelt på ugedag og time">
          <span className="st-hl" />
          {Array.from({ length: 24 }, (_, h) => <span key={h} className="st-hh">{h % 3 === 0 ? h : ""}</span>)}
          {heat.map((row, di) => (
            <Fragment key={di}>
              <span className="st-hl">{DAYS[di]}</span>
              {row.map((v, h) => (
                <span key={h} className={`st-hc l${level(v, max)}`} title={`${DAYS[di]} kl. ${h}: ${v} ja tak`} />
              ))}
            </Fragment>
          ))}
        </div>
      </div>
      <div className="st-heat-legend" data-testid="stats-heat-legend">
        <span>Færre</span>
        {[0, 1, 2, 3, 4].map((l) => <span key={l} className={`st-hc l${l}`} />)}
        <span>Flere</span>
        <span className="muted">· {count} ja tak i alt</span>
      </div>
    </section>
  );
}
